import { Divider, Menu, Typography } from "@mui/material"
import { useSelector } from "react-redux"
import { ALBUM_LAYOUTS, ALBUM_SORTINGS } from "../../../../utils/constants/enumConstants"
import { AlbumLayoutItem, AlbumOrderItem } from "./AlbumLayoutOrderItem";
import { getSavedAlbumsLayout, getSavedAlbumsOrder } from "../../../../reducers/albumListState";

const AlbumLayoutOrderMenu = ({open, anchor, closeHandler}) => {
    const OrderOptions = () => {
        const selectedOrder = useSelector(getSavedAlbumsOrder);

        return (
            <>
                <Typography variant="subtitle1" align="center" color="primary">Order criteria</Typography>
                {
                    Object.keys(ALBUM_SORTINGS).map((elementKey, index) => 
                        <AlbumOrderItem 
                            key={index}
                            elementKey={elementKey}
                            elementValue={ALBUM_SORTINGS[elementKey]}
                            selectedOrder={selectedOrder}
                        />)
                }
            </>
        )
    };

    const LayoutOptions = () => {
        const selectedLayout = useSelector(getSavedAlbumsLayout);

        return (
            <>
                <Typography variant="subtitle1" align="center" color="primary">Layout mode</Typography>
                {
                    Object.keys(ALBUM_LAYOUTS).map((elementKey, index) => 
                        <AlbumLayoutItem
                            key={index}
                            elementKey={elementKey}
                            elementValue={ALBUM_LAYOUTS[elementKey]}
                            selectedLayout={selectedLayout}
                        />)
                }
            </>
        )
    };

    return (
        <Menu
            open={open}
            onClose={closeHandler}
            anchorEl={anchor}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
        >
            <div className="d-flex flex-column gap-0_5">
                <OrderOptions />
                <Divider />
                <LayoutOptions />
            </div>
        </Menu>
    )
}

export default AlbumLayoutOrderMenu;